export default "__VITE_ASSET__9fe97802__"